const routes = {
  main: {
    name: 'Site',
    path: import.meta.env.VITE_APP_MAIN_HOST,
  },
  staff: {
    name: 'Staff',
    path: `${import.meta.env.VITE_APP_MAIN_HOST}/staff`,
  },
  sidekiq: {
    name: 'Sidekiq',
    path: `${import.meta.env.VITE_APP_MAIN_HOST}/sidekiq`,
  },
  termsAndConditions: {
    name: 'Terms and Conditions',
    path: `${import.meta.env.VITE_APP_MAIN_HOST}/terms-and-conditions`,
  },
  privacyPolicy: {
    name: 'Privacy Policy',
    path: `${import.meta.env.VITE_APP_MAIN_HOST}/privacy-policy`,
  },
  root: {
    name: 'Home',
    path: '/',
  },
  home: {
    name: 'Home',
    path: '/home',
  },
  login: {
    name: 'Login',
    path: '/login',
  },
  passwordRecovery: {
    name: 'Password Recovery',
    path: '/password-recovery',
    container: 'PasswordRecovery',
  },
  passwordChange: {
    name: 'Password Change',
    path: '/password-recovery/:token',
    container: 'PasswordChange',
  },
  signup: {
    name: 'Sign Up',
    path: '/signup',
    container: 'Signup',
  },
  settings: {
    name: 'Settings',
    path: '/settings',
    container: 'Settings',
  },
  signupComplete: {
    name: 'Welcome on board!',
    path: '/signup/welcome',
    container: 'SignupComplete',
  },
  confirmAccount: {
    name: 'Confirm Account',
    path: '/confirm-account',
    container: 'ConfirmAccount',
  },
  dashboardEmpty: {
    name: 'Dashboard',
    path: '/dashboard/new',
    container: 'DashboardEmpty',
  },
  dashboard: {
    name: 'Dashboard',
    path: '/dashboard',
  },
  monthlyView: {
    name: 'Monthly View',
    path: '/monthly-view',
    container: 'MonthlyView',
  },
  monthlyViewBoard: {
    name: 'Monthly View',
    path: '/monthly-view/:boardId',
    container: 'MonthlyView',
  },
  boards: {
    name: 'Boards',
    path: '/boards',
    container: 'Boards',
  },
  calendar: {
    name: 'Calendar',
    path: '/calendar',
  },
  templates: {
    name: 'Templates',
    path: '/templates',
  },
  scribbler: {
    name: 'Scribbler',
    path: '/scribbler',
  },
};

export default routes;
